/**
 * @generated SignedSource<<0be8da337a05a02cca34308a95fc576a>>
 * @relayHash b08192541f6dadc77d4bacab16163a55
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 207bfd7c801f72741185aa635e9c24c24c7bcd9a889d5f6ecfaa69eeeb0d35ce

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type inheritancePopupQuery$variables = {
  issueId: string;
};
export type inheritancePopupQuery$data = {
  readonly jira: {
    readonly getProjectLinkInheritanceSources: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"inheritancePopup_issueFieldAtlasProjectCommon_InheritancePopupContent">;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type inheritancePopupQuery = {
  response: inheritancePopupQuery$data;
  variables: inheritancePopupQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "issueId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "issueId",
    "variableName": "issueId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "inheritancePopupQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssueTownsquareProjectLink",
            "kind": "LinkedField",
            "name": "getProjectLinkInheritanceSources",
            "plural": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "inheritancePopup_issueFieldAtlasProjectCommon_InheritancePopupContent"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "inheritancePopupQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssueTownsquareProjectLink",
            "kind": "LinkedField",
            "name": "getProjectLinkInheritanceSources",
            "plural": true,
            "selections": [
              {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "summary"
                  },
                  {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "issueType",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "xsmall"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      (v2/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "webUrl"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "linkType"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "207bfd7c801f72741185aa635e9c24c24c7bcd9a889d5f6ecfaa69eeeb0d35ce",
    "metadata": {},
    "name": "inheritancePopupQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "600dd4544a21bd6cf3876c430837d737";

export default node;
